import SentryClient from '@/helpers/sentry';
import { ActionTree } from 'vuex';
import { BoardsGroupState } from './state';
import RootState from '@/store/root_state';
import { getBoardsGroupsByCourseIdQuery } from '@/store/queries/westerosQueries';
import { BoardsGroupInfo } from '@descomplica/dex-models';
import { MICROSERVICES_ENUM, graphqlQuery } from '@/helpers/apollo';

const actions: ActionTree<BoardsGroupState, RootState> = {
  async GET_BOARDS_GROUPS_FROM_COURSE({ commit }, { courseId }: { courseId: number }) {
    try {
      const response = await graphqlQuery(
        MICROSERVICES_ENUM.BOARDSGROUPS,
        getBoardsGroupsByCourseIdQuery,
        { courseId },
      );
      const boardsGroups = response?.data.getBoardsGroupsByCourseId;

      if (!boardsGroups) return;

      commit('SET_BOARDS_GROUPS', boardsGroups);
      commit(
        'SET_GROUPS',
        boardsGroups.map((boardsGroup: BoardsGroupInfo) => boardsGroup.groups).flat(),
      );
    } catch (e) {
      SentryClient.captureError(e);
    }
  },
};

export default actions;
